module.exports = __webpack_public_path__ + "static/media/1992-Impreza-GF-WRX.3f9348a0.jpg";